<template>
    <v-container fluid>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialogInitial" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('selecciona_caseta')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form
                                @submit.prevent="setGuardHouse()">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                        v-model="guardHouse"
                                        name="guardHouse"
                                        :items="guardHouses"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('Casetas')"
                                        autocomplete="off"
                                ></v-autocomplete>
                            </v-col>
                            <v-btn
                                    color="primary"
                                    type="submit"
                            >{{ $t('aceptar') }}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAdditionalPersonCode"
                persistent
                scrollable
                width="500">
            <v-card class="elevation-5">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{ $t('additional_person') }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogAdditionalPersonCode = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-col>
                        <v-row aling="center">
                            <h3>{{$t('select_video_device')}}</h3>
                        </v-row>
                        <v-row>
                            <v-col cols="10">
                                <v-select
                                        small
                                        v-model="camera3"
                                        :items="devices"
                                        label="Persona"
                                        item-text="label"
                                        item-value="deviceId"
                                ></v-select>
                            </v-col>
                            <v-col cols="2">
                              <v-icon large @click="onStart3">mdi-refresh</v-icon>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-card
                            class="mx-auto"
                            tile
                    >
                        <v-img
                                width="100%"
                                :src="imageCapturedAdditionalPerson !== '' ? imageCapturedAdditionalPerson : require('../../assets/noimage.png')"
                        >
                            <v-row
                                    align="end"
                                    class="fill-height"
                            >
                                <v-col
                                        align-self="start"
                                        class="pa-0"
                                        cols="12"
                                >
                                    <v-avatar
                                            class="profile"
                                            color="grey"
                                            size="164"
                                            tile
                                    >
                                        <div v-show="band" @click="onCaptureAdditionalPerson()">
                                            <vue-web-cam
                                                    ref="webcam3"
                                                    :device-id="deviceId3"
                                                    width="100%"
                                                    @started="onStarted3"
                                                    @stopped="onStopped"
                                                    @error="onError"
                                                    @cameras="onCameras"
                                                    @camera-change="onCameraChange3"
                                            />
                                        </div>
                                    </v-avatar>
                                </v-col>
                            </v-row>
                        </v-img>
                    </v-card>
                  <div class="text-center">
                    {{$t('msg_captura_foto')}}
                  </div>
                    <br><br>
                    <v-text-field
                      v-model="editedItem.full_name"
                      autofocus
                      prepend-icon="mdi-account"
                      name="first_name"
                      :label="$t('full_name')"
                      outlined>
                    </v-text-field>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                        large
                        color="error"
                        @click="dialogAdditionalPersonCode = false"
                    >{{$t('cerrar')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        :disabled="editedItem.full_name.length === 0 || imageCapturedAdditionalPerson === ''"
                        large
                        color="success"
                        @click="addResident()"
                    >{{$t('agregar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card
                width="1500"
                class="mx-auto elevation-7 font-weight-bold"
        >
            <v-toolbar dark color="primary">
                <v-icon v-if="getProfile.enable_parcel === false">mdi-truck</v-icon>
                <v-checkbox hide-details class="shrink mr-2" v-if="getProfile.enable_parcel === false" v-model="bandParcel" color="black"></v-checkbox>
                        {{getProfile.enable_parcel === false ? $t('parcel_capital_letters') : ''}}
                        <v-btn text router to="/events"><v-icon >mdi-calendar-star</v-icon>{{$t('events')}}</v-btn>
                        <v-btn text router to="/delivery"><v-icon>mdi-moped</v-icon>Delivery</v-btn>
                        <v-spacer/>
                <v-toolbar-title>
                    {{$t('access_without_code')}}
                </v-toolbar-title>
                <v-spacer/>
                <v-switch v-if="devices.length > 1" v-model="bandOneCam" color="secondary" label="Usar sólo una Cámara"></v-switch>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col
                            cols="12"
                            sm="6"
                    >
                        <v-alert
                            v-show="bandMsgVacationMode"
                            type="error"
                            outlined
                        >
                          <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                        </v-alert>
                        <v-alert
                            v-show="bandInstructions"
                            type="info"
                            outlined
                        >
                          <strong>{{ msgInstructions }}</strong>
                        </v-alert>
                        <br>
                        <v-autocomplete
                            v-if="getProfile.idHousingUnit !== 'bc7c051d-56eb-4dbf-b627-eca69ece6541'"
                            v-show="bandParcel"
                            v-model="idHouse2"
                            :search-input.sync="searchInput"
                            @change="searchInput=''"
                            prepend-icon="mdi-home-city"
                            name="idHouse2"
                            :item-text="example"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_street_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            outlined
                            multiple
                            chips
                            clearable
                            autocomplete="off"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >
                              {{ data.item.street }} {{data.item.number}}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title>{{ data.item.street }} {{data.item.number}}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-else
                            v-show="bandParcel"
                            v-model="idHouse2"
                            :search-input.sync="searchInput"
                            @change="searchInput=''"
                            prepend-icon="mdi-home-city"
                            name="idHouse2"
                            :item-text="example"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            outlined
                            multiple
                            chips
                            clearable
                            autocomplete="off"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                                large
                                v-if="getProfile.show_house_phones === false"
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >
                              <strong>{{ data.item.street }} {{data.item.number}}</strong>
                            </v-chip>
                            <v-chip
                                v-else
                                large
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >
                              <strong>{{ data.item.street }} {{data.item.number}} ({{data.item.phone === null ? 'n/a' : data.item.phone}}) ({{data.item.phone2 === null ? 'n/a' : data.item.phone2}}) ({{data.item.phone3 === null ? 'n/a' : data.item.phone3}})</strong>
                            </v-chip>
                          </template>
                          <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                            <v-spacer/>
                            <v-btn-toggle>
                              <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </template>
                          <template v-slot:item="data" v-else>
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-show="getProfile.booth_registration === false && !bandParcel"
                            v-model="idHouse"
                            prepend-icon="mdi-home-city"
                            name="idHouse"
                            :item-text="getProfile.show_house_phones === false ? example : example2"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_street_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            clearable
                            outlined
                            return-object
                            autocomplete="off"
                            @change="showMessageVacationMode"
                        >
                          <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                            <v-spacer/>
                            <v-btn-toggle>
                              <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </template>
                          <template v-slot:item="data" v-else>
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-show="getProfile.booth_registration === true && getProfile.idHousingUnit === 'bc7c051d-56eb-4dbf-b627-eca69ece6541' && !bandParcel"
                            v-model="idHouse"
                            prepend-icon="mdi-home-city"
                            name="idHouse"
                            :item-text="getProfile.show_house_phones === false ? example : example2"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_street_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            clearable
                            outlined
                            return-object
                            autocomplete="off"
                            @change="showMessageVacationMode"
                        >
                          <template v-slot:item="data">
                            <template v-if="getProfile.show_house_phones === false">
                              <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                              <v-spacer/>
                              <v-btn-toggle>
                                <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                              </v-btn-toggle>
                            </template>
                            <template v-else>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                  </v-list-item-title>
                                </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-show="getProfile.booth_registration === true && getProfile.idHousingUnit !== 'bc7c051d-56eb-4dbf-b627-eca69ece6541' && !bandParcel"
                            v-model="idHouse"
                            prepend-icon="mdi-home-city"
                            name="idHouse"
                            :item-text="getProfile.show_house_phones === false ? example : example3"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_house_number_resident')"
                            :filter="customFilterNumberResident"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            clearable
                            outlined
                            return-object
                            autocomplete="off"
                            @change="showMessageVacationMode"
                        >
                          <template v-slot:item="data">
                            <template v-if="getProfile.show_house_phones === false">
                              <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                              <v-spacer/>
                              <v-btn-toggle>
                                <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                              </v-btn-toggle>
                            </template>
                            <template v-else>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{data.item.fullname === '' ? 'n/a' : data.item.fullname}}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <div class="text--accent-1" v-show="getProfile.show_directory_guards === true && !bandParcel">
                          <div class="ml-6" v-show="idHouse.phone !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name1 === null) || (idHouse.name1 === '')) ? 'n/a' : idHouse.name1}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone2 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name2 === null) || (idHouse.name2 === '')) ? 'n/a' : idHouse.name2}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone2}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone3 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name3 === null) || (idHouse.name3 === '')) ? 'n/a' : idHouse.name3}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone3}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone4 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name4 === null) || (idHouse.name4 === '')) ? 'n/a' : idHouse.name4}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone4}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone5 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name5 === null) || (idHouse.name5 === '')) ? 'n/a' : idHouse.name5}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone5}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone6 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name6 === null) || (idHouse.name6 === '')) ? 'n/a' : idHouse.name6}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone6}}</strong></h2><br></div><br>
                        </div>
                        <v-autocomplete
                                v-show="!bandParcel"
                                v-model="idService"
                                prepend-icon="mdi-tag-multiple"
                                name="idService"
                                :item-text="textServices"
                                item-value="name"
                                :label="$t('service_catalog')"
                                :placeholder="$t('search_by_name')"
                                :filter="customFilterService"
                                :items="services"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                autocomplete="off"
                        >
                            <template v-slot:item="data">
                                <strong>{{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                            </template>
                        </v-autocomplete>
                        <v-text-field
                                v-model="first_name"
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('full_name')"
                                outlined
                                :error-messages="errors.name_guest"
                        >
                        </v-text-field>
                        <v-alert
                                v-if="isRestrictedPerson"
                                type="error"
                                dense
                                outlined
                                class="mb-4"
                        >
                            {{ restrictedPersonMessage }}
                        </v-alert>
                        <v-btn
                                v-if="isRestrictedPerson && restrictedPersonPhoto"
                                color="error"
                                outlined
                                class="mb-4"
                                @click="dialogRestrictedPhoto = true"
                        >
                            <v-icon left>mdi-camera</v-icon> Ver foto actual
                        </v-btn>
                        <v-textarea
                                v-model="notes"
                                autocomplete="on"
                                prepend-icon="mdi-text"
                                name="notes"
                                :placeholder="$t('placeholder_notas')"
                                :label="$t('Notas')"
                                outlined
                                :error-messages="errors.comments"
                        ></v-textarea>
                        <div align="center">
                            <v-btn
                                    large
                                    color="primary"
                                    @click="createAccessNoCode()"
                                    :loading="loading"
                            >{{$t('enviar')}}
                            </v-btn>
                            <!-- <v-btn
                                large
                                color="primary"
                                @click="printTicket()"
                                :loading="printingTicket"
                            >
                                <v-icon left>mdi-printer</v-icon>
                                Imprimir Ticket
                            </v-btn> -->
                        </div>
                        <v-btn
                            v-if="bandParcel === false"
                            color="primary"
                            @click="cleanAdditionalPersonFields()"
                        >{{$t('additional_person')}}</v-btn>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12">
                            <div v-if="bandParcel === false">
                              <v-data-table
                                  :headers="headers"
                                  :items="additionalPersons"
                                  :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                                  :no-data-text="$t('no_records_yet')"
                                  class="elevation-1"
                              >
                                <template v-slot:item.full_name="{ item }">
                                  {{ item.full_name}}
                                </template>
                                <template v-slot:item.action="{ item }">
                                  <v-icon
                                      medium
                                      color="grey"
                                      class="mr-2"
                                      @click="editResident(item)"
                                  >
                                    mdi-pencil
                                  </v-icon>
                                  <v-icon
                                      medium
                                      color="red"
                                      @click="deleteResident(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </div>
                          </v-col>
                        </v-row>
                    </v-col>
                    <v-col
                            cols="12"
                            sm="6"
                    >
                        <v-layout justify-center class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" row wrap>
                            <v-col>
                                <!-- Camera Mode Selector -->
                                <v-radio-group v-model="cameraMode" row @change="switchCameraMode" class="mb-1 mt-0">
                                  <v-radio label="Cámara Local" value="local"></v-radio>
                                  <v-radio label="Cámara intrare" value="server"></v-radio>
                                </v-radio-group>

                                <!-- Local: selectors de dispositivo -->
                                <div v-if="cameraMode === 'local'">
                                  <v-row aling="center">
                                      <h3>{{$t('select_video_device')}}</h3>
                                  </v-row>
                                  <v-row>
                                  <v-col cols="6">
                                      <v-select
                                              small
                                              v-model="camera"
                                              :items="devices"
                                              label="Persona"
                                              item-text="label"
                                              item-value="deviceId"
                                      ></v-select>
                                  </v-col>
                                  <v-col v-if="devices.length > 1 && !bandOneCam" cols="6">
                                      <v-select
                                              v-model="camera2"
                                              :items="devices"
                                              label="Placas"
                                              item-text="label"
                                              item-value="deviceId"
                                      ></v-select>
                                  </v-col>
                                  </v-row>
                                </div>

                                <!-- Server: selector de cámara del servidor -->
                                <div v-if="cameraMode === 'server' && serverCameras.length > 0">
                                  <v-row aling="center">
                                      <h3>Seleccionar Cámara del Servidor</h3>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-select
                                        outlined
                                        small
                                        v-model="selectedServerCamera"
                                        :items="serverCameras"
                                        label="Cámara"
                                        item-text="name"
                                        return-object
                                        @change="onServerCameraChange"
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                </div>
                            </v-col>
                            <v-card
                                    class="mx-auto"
                                    tile
                            >
                                <v-img
                                        width="100%"
                                        :src="imageCaptured !== '' ? imageCaptured : require('../../assets/noimage.png')"
                                >
                                    <v-row
                                            align="end"
                                            class="fill-height"
                                    >
                                        <v-col
                                                align-self="start"
                                                class="pa-0"
                                                cols="12"
                                        >
                                            <!-- Local cameras — estructura original sin cambios -->
                                            <v-avatar
                                                    v-if="cameraMode === 'local'"
                                                    class="profile"
                                                    color="grey"
                                                    size="164"
                                                    tile
                                            >
                                                <div v-show="band2" @click="onCapture()">
                                                    <vue-web-cam
                                                            ref="webcam"
                                                            :device-id="deviceId"
                                                            width="100%"
                                                            @started="onStarted"
                                                            @stopped="onStopped"
                                                            @error="onError"
                                                            @cameras="onCameras"
                                                            @camera-change="onCameraChange"
                                                    />
                                                </div>
                                            </v-avatar>
                                            <v-avatar
                                                    v-if="cameraMode === 'local'"
                                                    v-show="devices.length > 1 && !bandOneCam"
                                                    class="profile"
                                                    color="grey"
                                                    size="164"
                                                    tile
                                            >
                                                <div v-show="band2" @click="onCapture()">
                                                    <vue-web-cam
                                                            ref="cameraDos"
                                                            :device-id="deviceId2"
                                                            width="100%"
                                                            @started="onStarted"
                                                            @stopped="onStopped"
                                                            @error="onError"
                                                            @camera-change="onCameraChange2"
                                                    />
                                                </div>
                                            </v-avatar>

                                            <!-- Server camera — div en lugar de v-avatar para que <video> se renderice -->
                                            <div v-if="cameraMode === 'server'" class="camera-preview-box">
                                              <video
                                                ref="videoPersona"
                                                autoplay
                                                muted
                                                playsinline
                                                style="width:100%;height:100%;object-fit:cover;display:block;cursor:pointer;"
                                                @click="onCapture()"
                                              ></video>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-img>
                            </v-card>
                                <br>
                                <v-alert
                                        v-if="errors.photo"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errors.photo}}
                                </v-alert>
                                <br>
                            {{$t('msg_captura_foto')}}
                        </v-layout>
                    </v-col>
                </v-row>
              <div v-show="false">
                <vue-web-cam
                        ref="webcam3"
                        :device-id="deviceId3"
                        width="100%"
                        @stopped="onStopped"
                        @error="onError"
                />
              </div>
            </v-card-text>
        </v-card>
        <!-- Diálogo de ticket de acceso exitoso -->
        <v-dialog v-model="dialogTicket" persistent max-width="400px">
            <v-card class="elevation-10">
                <v-toolbar dark color="success">
                    <v-icon left>mdi-check-circle</v-icon>
                    <v-toolbar-title>Acceso Registrado</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeTicketDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pt-4 pb-2">
                    <div class="text-center mb-3">
                        <v-icon color="success" size="48">mdi-account-check</v-icon>
                    </div>
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-icon><v-icon color="primary">mdi-account</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>Nombre</v-list-item-subtitle>
                                <v-list-item-title class="font-weight-bold">{{ ticketData.name }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon color="primary">mdi-clock-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>Fecha y Hora</v-list-item-subtitle>
                                <v-list-item-title class="font-weight-bold">{{ ticketData.dateTime }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon color="primary">mdi-qrcode</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>ID de Acceso</v-list-item-subtitle>
                                <v-list-item-title class="font-weight-bold text-truncate">{{ ticketData.id }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions class="justify-center pb-4">
                    <v-btn
                        large
                        color="primary"
                        @click="printTicket()"
                        :loading="printingTicket"
                    >
                        <v-icon left>mdi-printer</v-icon>
                        Imprimir Ticket
                    </v-btn>
                    <v-btn
                        large
                        color="grey lighten-1"
                        @click="closeTicketDialog()"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Diálogo para ver foto de persona restringida -->
        <v-dialog v-model="dialogRestrictedPhoto" max-width="600px">
            <v-card class="pa-2" color="grey darken-4">
                <v-card-actions class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogRestrictedPhoto = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-card-text class="pa-2">
                    <v-img
                            v-if="restrictedPersonPhoto"
                            :src="restrictedPersonPhoto"
                            contain
                            max-height="550"
                    ></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import QRCode from 'qrcode'
import JsPDF from 'jspdf'
import store from '@/store'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'access_without_code',
  components: {
    'vue-web-cam': WebCam
  },
  data () {
    return {
      camera: null,
      camera2: null,
      camera3: null,
      devices: [ ],
      deviceId: null,
      deviceId2: null,
      deviceId3: null,
      band: false,
      band2: false,
      houses: [],
      imageCaptured: '',
      imageCapturedAdditionalPerson: '',
      imageCaptured2: '',
      errors: [],
      first_name: '',
      isRestrictedPerson: false,
      restrictedPersonMessage: '',
      restrictedPersonPhoto: '',
      dialogRestrictedPhoto: false,
      restrictionCheckTimeout: null,
      celular: '',
      // band_cellphone: false,
      notes: '',
      idHouse: {
        id: ''
      },
      idHouse2: [],
      searchInput: '',
      dialogInitial: false,
      guardHouse: null,
      guardHouses: [],
      loading: false,
      bandOneCam: false,
      bandParcel: false,
      bandMsgVacationMode: false,
      bandInstructions: false,
      msgInstructions: '',
      idService: '',
      services: [],
      // VARIABLES AGREGAR ACOMPANANTES
      dialogAdditionalPersonCode: false,
      bandAdditionalPersonCode: false,
      headers: [],
      additionalPersons: [],
      editedIndex: -1,
      edit: false,
      editedItem: {
        full_name: '',
        data: '',
        classification: '',
        label: ''
      },
      defaultItem: {
        full_name: '',
        data: '',
        classification: '',
        label: ''
      },
      imageCapturedAdditional: '',
      // VARIABLES AGREGAR ACOMPANANTES
      idGuestByEvent: null,
      idGuestByDelivery: null,
      idGuestByTournament: null,
      // Camera Server Integration
      cameraMode: 'local',
      serverIP: localStorage.getItem('camera_server_ip') || '127.0.0.1:7000',
      serverCameras: [],
      selectedServerCamera: null,
      peerConnection: null,
      cameraAPI: null,
      webrtcNegotiating: false,
      // Ticket dialog
      dialogTicket: false,
      printingTicket: false,
      ticketData: {
        id: '',
        name: '',
        dateTime: '',
        nameHousingUnit: '',
        logo: ''
      }
    }
  },
  beforeDestroy () {
    this.closeServerCamera()
  },
  created: async function () {
    await this.getHouses()
    await this.getServices()
    await this.getGuardHouse()
    if (localStorage.getItem('idGuardHouse') === null) {
      this.dialogInitial = true
    }
    if (this.getProfile.booth_registration === true) {
      this.bandOneCam = true
    }
    console.log(this.$route.params)
    console.log('Tamaño =', Object.keys(this.$route.params).length)
    if (Object.keys(this.$route.params).length > 2) {
      if (this.$route.params.type === 0) { // EVENTO
        this.first_name = this.$route.params.fullNameGuest + ' (EVENTO)'
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByEvent = this.$route.params.idGuestByEvent
        this.notes = this.$route.params.eventName
      } else if (this.$route.params.type === 4) { // TORNEO / CASA CLUB
        this.first_name = this.$route.params.fullNameGuest + ' (TORNEO)'
        this.idGuestByTournament = this.$route.params.idGuestByTournament
        this.notes = this.$route.params.tournamentName
        this.setTournamentHouse()
      } else { // DELIVERY
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByDelivery = this.$route.params.idGuestByDelivery
        this.notes = this.$route.params.notes
        this.first_name = this.$route.params.personName
      }
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    device () {
      return this.devices.find(n => n.deviceId === this.deviceId)
    }
  },
  watch: {
    first_name (val) {
      if (this.restrictionCheckTimeout) {
        clearTimeout(this.restrictionCheckTimeout)
      }
      if (!val || val.trim().length < 3) {
        this.isRestrictedPerson = false
        this.restrictedPersonMessage = ''
        return
      }
      this.restrictionCheckTimeout = setTimeout(() => {
        this.checkRestrictedPerson(val)
      }, 500)
    },
    camera (id) {
      this.deviceId = id
    },
    camera2 (id) {
      this.deviceId2 = id
    },
    camera3 (id) {
      this.deviceId3 = id
    },
    devices () {
      console.log('Hola')
      // Once we have a list select the first one
      const [first, second, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
        this.camera3 = first.deviceId
        this.deviceId3 = first.deviceId
      } else {
        this.camera = tail.deviceId
        this.deviceId = tail.deviceId
        this.camera3 = first.deviceId
        this.deviceId3 = first.deviceId
      }
      if (this.devices.length > 1) {
        this.camera2 = second.deviceId
        this.deviceId2 = second.deviceId
        this.camera3 = first.deviceId
        this.deviceId3 = first.deviceId
      }
    }
  },
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'full_name'
      }
    ]
  },
  methods: {
    async checkRestrictedPerson (name) {
      try {
        let url = `https://residencial-services.intrare.app/people/?search=${encodeURIComponent(name)}&is_active=true`
        if (this.getProfile && this.getProfile.idHousingUnit) {
          url += `&housing_unit=${this.getProfile.idHousingUnit}`
        }
        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        const found = response.data.find(p => p.fullName.trim().localeCompare(name.trim(), 'es', { sensitivity: 'base' }) === 0)
        if (found) {
          this.isRestrictedPerson = true
          this.restrictedPersonMessage = `Atención: ${found.fullName} esta en la lista de personas restringidas. ${found.notes ? 'Notas: ' + found.notes : ''}`
          this.restrictedPersonPhoto = found.photo || ''
        } else if (response.data.length > 0) {
          this.isRestrictedPerson = true
          this.restrictedPersonMessage = `Atención: Hay personas restringidas con nombres similares (${response.data.map(p => p.fullName).join(', ')}).`
        } else {
          this.isRestrictedPerson = false
          this.restrictedPersonMessage = ''
        }
      } catch (error) {
        console.error('Error verificando persona restringida', error)
      }
    },
    remove: function (item) {
      console.log(this.idHouse2)
      console.log(this.idHouse2[0])
      const index = this.idHouse2.indexOf(item.id)
      console.log(index)
      if (index >= 0) this.idHouse2.splice(index, 1)
    },
    deleteHeadFromImages (imagen) {
      return imagen.replace('data:image/jpeg;base64,', '')
    },
    async asyncCall () {
      const loadImg = src => new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = 'data:image/jpeg;base64,' + src
      })
      const [img1, img2] = await Promise.all([loadImg(this.imageCaptured), loadImg(this.imageCaptured2)])
      const canvas = document.createElement('canvas')
      canvas.width = Math.max(img1.width, img2.width)
      canvas.height = img1.height + img2.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img1, 0, 0)
      ctx.drawImage(img2, 0, img1.height)
      this.imageCaptured = canvas.toDataURL('image/jpeg')
    },
    onCapture () {
      if (this.cameraMode === 'local') {
        this.imageCaptured = this.$refs.webcam.capture()
        if (this.devices.length > 1 && !this.bandOneCam) {
          this.imageCaptured2 = this.$refs.cameraDos.capture()
          this.imageCaptured = this.deleteHeadFromImages(this.imageCaptured)
          this.imageCaptured2 = this.deleteHeadFromImages(this.imageCaptured2)
          this.asyncCall()
        }
      } else if (this.cameraMode === 'server') {
        const videoEl = this.$refs.videoPersona
        if (!videoEl) return
        const canvas = document.createElement('canvas')
        canvas.width = videoEl.videoWidth || 640
        canvas.height = videoEl.videoHeight || 480
        canvas.getContext('2d').drawImage(videoEl, 0, 0, canvas.width, canvas.height)
        this.imageCaptured = canvas.toDataURL('image/jpeg')
      }
    },
    // ── Camera Server Methods ──────────────────────────────────────────
    initCameraAPI () {
      this.cameraAPI = axios.create({
        baseURL: `http://${this.serverIP}`,
        headers: { 'Content-Type': 'application/json' },
        timeout: 5000
      })
    },
    async loadServerCameras () {
      try {
        if (!this.cameraAPI) this.initCameraAPI()
        const camerasRes = await this.cameraAPI.get('/api/cameras')
        const streamsRes = await this.cameraAPI.get('/api/streams')
        const streams = streamsRes.data.streams || streamsRes.data
        this.serverCameras = camerasRes.data.map(camera => {
          const stream = Array.isArray(streams) && streams.find(s => s.camera_id === camera.id)
          return Object.assign({}, camera, {
            stream_alias: (stream && stream.alias) || camera.alias
          })
        })
        if (this.serverCameras.length > 0) {
          this.selectedServerCamera = this.serverCameras[0]
          this.$nextTick(() => this.connectWebRTC(this.selectedServerCamera.stream_alias))
        }
      } catch (error) {
        console.error('Error loading server cameras:', error)
      }
    },
    async connectWebRTC (streamAlias) {
      if (this.webrtcNegotiating || !streamAlias) return
      this.webrtcNegotiating = true
      try {
        this.peerConnection = new RTCPeerConnection({
          iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }]
        })
        this.peerConnection.ontrack = (event) => {
          const videoEl = this.$refs.videoPersona
          if (videoEl) {
            videoEl.srcObject = event.streams[0]
            videoEl.play().catch(() => {})
          }
        }
        this.peerConnection.addTransceiver('video', { recv: true })
        const offer = await this.peerConnection.createOffer()
        await this.peerConnection.setLocalDescription(offer)
        const response = await fetch(`http://${this.serverIP}/api/webrtc/${streamAlias}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/sdp' },
          body: this.peerConnection.localDescription.sdp
        })
        if (!response.ok) throw new Error(`Server ${response.status}`)
        const sdp = await response.text()
        await this.peerConnection.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp }))
        this.webrtcNegotiating = false
      } catch (error) {
        console.error('WebRTC error:', error)
        this.closeServerCamera()
      }
    },
    closeServerCamera () {
      const videoEl = this.$refs.videoPersona
      if (videoEl) { videoEl.srcObject = null; videoEl.pause() }
      if (this.peerConnection) { this.peerConnection.close(); this.peerConnection = null }
      this.webrtcNegotiating = false
    },
    async switchCameraMode (mode) {
      if (mode === 'server') {
        this.imageCaptured = ''
        await this.loadServerCameras()
      } else {
        this.closeServerCamera()
        this.$nextTick(() => {
          if (this.$refs.webcam) this.$refs.webcam.start()
        })
      }
    },
    async onServerCameraChange () {
      if (this.selectedServerCamera) {
        this.closeServerCamera()
        await this.$nextTick()
        this.connectWebRTC(this.selectedServerCamera.stream_alias)
      }
    },
    // ── End Camera Server Methods ──────────────────────────────────────
    onCaptureAdditionalPerson () {
      this.imageCapturedAdditionalPerson = this.$refs.webcam3.capture()
    },
    onStarted (stream) {
      this.band2 = true
      console.log('On Started Event', stream)
    },
    onStarted3 (stream) {
      this.band = true
      console.log('On Started Event 3', stream)
    },
    onStopped (stream) {
      console.log('On Stopped Event', stream)
    },
    onStop () {
      this.$refs.webcam.stop()
      this.$refs.webcam3.stop()
      this.$refs.cameraDos.stop()
    },
    onStart () {
      this.$refs.webcam.start()
      this.$refs.webcam3.start()
      this.$refs.cameraDos.start()
    },
    onStart3 () {
      this.$refs.webcam3.start()
      this.onCameraChange3(this.deviceId3)
    },
    onError (error) {
      console.log('On Error Event', error)
    },
    onCameras (cameras) {
      this.devices = cameras
      console.log('On Cameras Event', cameras)
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    onCameraChange2 (deviceId) {
      this.deviceId2 = deviceId
      this.camera2 = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    onCameraChange3 (deviceId) {
      this.deviceId3 = deviceId
      this.camera3 = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/resident_house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      return axios(config)
        .then(response => {
          if (response.status === 204) {
            this.houses = []
          } else {
            this.houses = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getServices: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/service/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.services = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    example2: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')',
    example3: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')' + ' (' + (item.fullname === '' ? 'n/a' : item.fullname) + ')',
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    textServices: item => (item.name === null ? 'n/a' : item.name),
    customFilterNumberResident (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.number.toLowerCase() + item.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      }
      const searchText = queryText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      return text.indexOf(searchText) > -1
    },
    showMessageVacationMode () {
      console.log('Fill Houses')
      console.log(this.idHouse)
      if (this.idHouse === undefined) {
        this.idHouse = {
          id: ''
        }
        this.bandMsgVacationMode = false
        this.bandInstructions = false
        this.msgInstructions = ''
      } else {
        if (this.idHouse.vacation_mode && !this.idHouse.allow_access_visitors) {
          this.bandMsgVacationMode = true
        } else {
          this.bandMsgVacationMode = false
        }
        if (this.idHouse.instructions !== '' && this.idHouse.instructions !== null) {
          this.bandInstructions = true
          this.msgInstructions = this.idHouse.instructions
        } else {
          this.bandInstructions = false
          this.msgInstructions = ''
        }
      }
    },
    customFilterStreetResident (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      }
      const searchText = queryText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterNumber (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterService (item, queryText) {
      var text = ''
      if (item.name === null) {
        text = 'n/a'
      } else {
        text = item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanAdditionalPersonFields () {
      console.log('URL = ', this.$route.name)
      this.dialogAdditionalPersonCode = true
      this.imageCapturedAdditionalPerson = ''
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.onStart3()
    },
    addResident () {
      this.editedItem.full_name = this.editedItem.full_name
      this.editedItem.data = this.imageCapturedAdditionalPerson
      if (this.editedIndex > -1) {
        Object.assign(this.additionalPersons[this.editedIndex], this.editedItem)
      } else {
        this.additionalPersons.push(this.editedItem)
        console.log(this.editedItem)
        console.log('Resident Added')
      }
      this.dialogAdditionalPersonCode = false
    },
    editResident (item) {
      // console.log('ITEM = ', item)
      this.editedIndex = this.additionalPersons.indexOf(item)
      // console.log('INDEX EDIT ITEM = ', this.editedIndex)
      this.editedItem = Object.assign({}, item)
      this.imageCapturedAdditionalPerson = this.editedItem.data
      this.dialogAdditionalPersonCode = true
    },
    deleteResident (aResident) {
      const index = this.additionalPersons.indexOf(aResident)
      confirm('¿Está seguro de eliminar el Registro de ' + aResident.full_name + '?.\nEsta Acción no se puede deshacer!') && this.additionalPersons.splice(index, 1)
    },
    createRecordsAdditionalPeopleNoCode (id) {
      console.log('TAM ====> ', this.additionalPersons.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      for (let i = 0; i < this.additionalPersons.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('idAccess', id)
        bodyFormData.append('full_name', this.additionalPersons[i].full_name)
        fileImageFront = this.dataURLtoFile(this.additionalPersons[i].data, 'photo' + newID + '.jpeg')
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/additional_people_no_code_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    createManyAccessNoCode () {
      this.loading = true
      this.errors = []
      console.log('TAM ====> ', this.idHouse2.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      bodyFormData.append('housing_unit', this.getProfile.idHousingUnit)
      bodyFormData.append('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))
      bodyFormData.append('name_guest', this.first_name)
      bodyFormData.append('comments', this.notes)

      for (let i = 0; i < this.idHouse2.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('house', this.idHouse2[i])
        if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
          fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
        }
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_many_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          console.log('ID del nuevo registro (many) = ', ok.data.id)
          // Guardar datos del ticket para mostrar el diálogo
          this.ticketData = {
            id: ok.data.id || '',
            name: ok.data.name_guest || this.first_name || '',
            dateTime: ok.data.dateTime_EntranceAccess || '',
            nameHousingUnit: ok.data.nameHousingUnit || '',
            logo: ok.data.logo || ''
          }
          this.loading = false
          // Mostrar el diálogo del ticket. Modificar Valor de UUID del fraccionamiento para la prueba
          if (this.getProfile.idHousingUnit === '328c5156-d5fd-4558-a185-512fafd9eee1') {
            this.dialogTicket = true
          } else {
            this.closeTicketDialog()
          }
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    createAccessWithoutCode () {
      this.loading = true
      this.errors = []
      console.log('Access Without Code Created ....')
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('housing_unit', this.getProfile.idHousingUnit)
      bodyFormData.set('house', this.idHouse.id)
      if (this.idService !== undefined && this.idService.length > 0 && (this.first_name !== '')) {
        bodyFormData.set('name_guest', this.first_name + ' ' + '(' + this.idService.toUpperCase() + ')')
      } else {
        bodyFormData.set('name_guest', this.first_name)
      }
      bodyFormData.set('comments', this.notes)
      if (this.additionalPersons.length > 0) {
        bodyFormData.set('additionalPerson', 'true')
      }
      bodyFormData.set('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))

      if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
        fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
      }
      bodyFormData.append('photo', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          console.log('ID del nuevo registro = ', ok.data.id)
          // Guardar datos del ticket para mostrar el diálogo
          this.ticketData = {
            id: ok.data.id || '',
            name: ok.data.name_guest || this.first_name || '',
            dateTime: ok.data.dateTime_EntranceAccess || '',
            nameHousingUnit: ok.data.nameHousingUnit || '',
            logo: ok.data.logo || ''
          }
          if (this.additionalPersons.length > 0) {
          //   Llamar a funcion que genere registros de personas adicionales
            this.createRecordsAdditionalPeopleNoCode(ok.data.id)
          } else {
            this.loading = false
          }
          if (this.idGuestByEvent !== null) {
            console.log('Se actualiza Registro de Acceso de la invitado al Evento.')
            this.changeStatusGuestByEvent(ok.data.id)
          }
          if (this.idGuestByDelivery !== null) {
            console.log('Se actualiza Registro de Acceso al Delivery.')
            this.changeStatusGuestByDelivery(ok.data.id)
          }
          if (this.idGuestByTournament !== null) {
            console.log('Se actualiza Registro de Acceso del Torneo.')
            this.changeStatusGuestByTournament(ok.data.id)
          }
          // Mostrar el diálogo del ticket. Modificar Valor de UUID del fraccionamiento para la prueba
          if (this.getProfile.idHousingUnit === '328c5156-d5fd-4558-a185-512fafd9eee1') {
            this.dialogTicket = true
          } else {
            this.closeTicketDialog()
          }
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    changeStatusGuestByEvent (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/event/guest/status/' + this.idGuestByEvent + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    changeStatusGuestByDelivery (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/delivery/' + this.idGuestByDelivery,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    changeStatusGuestByTournament (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/tournament/access/' + this.idGuestByTournament + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          attended: true,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Torneo actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Torneo.', error)
        })
    },
    setTournamentHouse () {
      // El acceso de Torneo/Casa Club siempre entra por la casa "Casa Club"
      const casaClub = this.houses.find(house => {
        const nameUpper = (house.name || house.street || '').toUpperCase()
        return nameUpper.includes('CASA CLUB') ||
               (nameUpper.includes('CASA') && nameUpper.includes('CLUB')) ||
               nameUpper === 'CLUB' ||
               nameUpper === 'CASA CLUB'
      })
      this.idHouse = casaClub ? { id: casaClub.id, ...casaClub } : { id: '' }
    },
    createAccessNoCode () {
      console.log('idHouse = ', this.idHouse)
      console.log('idHouse2 = ', this.idHouse2)
      this.errors = []
      const words = this.first_name.trim().split(/\s+/)
      if (words.length < 2 || words[0] === '' || words[1] === '') {
        this.errors = {
          name_guest: [this.$t('error_name_min_two_words')]
        }
        return
      }

      if (this.bandParcel === true) {
        this.createManyAccessNoCode()
      } else {
        this.createAccessWithoutCode()
      }
    },
    getGuardHouse: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/guardhouse/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guardHouses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    closeTicketDialog () {
      this.dialogTicket = false
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', this.$t('access_success'))
      setTimeout(this.clear, 3000)
    },
    async printTicket () {
      this.printingTicket = true
      try {
        const mmToPt = 2.83465
        const ticketW = 80 * mmToPt // Antes era 58
        const ticketH = 110 * mmToPt
        // Generar QR como Data URL
        const qrDataUrl = await QRCode.toDataURL(String(this.ticketData.id), {
          width: 300,
          margin: 1,
          errorCorrectionLevel: 'M',
          color: { dark: '#000000', light: '#ffffff' }
        })
        const doc = new JsPDF('p', 'pt', [ticketW, ticketH])
        // Helper para centrar texto
        const centerText = (text, y) => {
          const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor
          const textOffset = (ticketW - textWidth) / 2
          doc.text(text, textOffset, y)
        }
        // Fondo blanco
        doc.setFillColor(255, 255, 255)
        doc.rect(0, 0, ticketW, ticketH, 'F')
        let currentY = 5 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8)
        doc.setTextColor(0, 0, 0)
        const divider = '================================'
        centerText(divider, currentY)
        currentY += 3.5 * mmToPt
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(9)
        centerText('Intrare Residencia', currentY)
        currentY += 3 * mmToPt
        // Nombre del fraccionamiento (sin logo)
        if (this.ticketData.nameHousingUnit) {
          doc.setFont('helvetica', 'normal')
          doc.setFontSize(7)
          const nameHULines = doc.splitTextToSize(this.ticketData.nameHousingUnit, ticketW - (6 * mmToPt))
          nameHULines.forEach(line => {
            centerText(line, currentY)
            currentY += 3 * mmToPt
          })
          currentY += 1 * mmToPt
        }
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8)
        centerText(divider, currentY)
        currentY += 5 * mmToPt
        const leftMargin = 14 * mmToPt // Antes era 6
        doc.setFontSize(7)
        doc.text(`Fecha: ${this.ticketData.dateTime}`, leftMargin, currentY)
        currentY += 3.5 * mmToPt
        // Ajustar el nombre si es muy largo
        const nameLines = doc.splitTextToSize(`Visitante: ${this.ticketData.name}`, ticketW - (28 * mmToPt)) // Antes era 6
        nameLines.forEach(line => {
          doc.text(line, leftMargin, currentY)
          currentY += 3.5 * mmToPt
        })
        currentY += 1.5 * mmToPt
        doc.setFontSize(8)
        centerText(divider, currentY)
        currentY += 2 * mmToPt
        // QR Code (mismo tamaño)
        const qrSize = 35 * mmToPt
        const qrX = (ticketW - qrSize) / 2
        doc.addImage(qrDataUrl, 'PNG', qrX, currentY, qrSize, qrSize)
        currentY += qrSize + 3 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8)
        centerText(divider, currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(8)
        centerText('IMPORTANTE', currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(7)
        centerText('Escanee el QR en el módulo', currentY)
        currentY += 3 * mmToPt
        centerText('de salida antes de retirarse.', currentY)
        currentY += 3 * mmToPt
        centerText('Válido una sola vez.', currentY)
        currentY += 5 * mmToPt
        centerText('Conserve este ticket hasta', currentY)
        currentY += 3 * mmToPt
        centerText('completar su salida.', currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(8)
        centerText('¡Gracias por su visita!', currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'italic')
        doc.setFontSize(5)
        try {
          const logoImg = new Image()
          logoImg.crossOrigin = 'Anonymous'
          logoImg.src = 'https://intrareres.s3.us-east-2.amazonaws.com/static/Icons/inrtare02.png'
          await new Promise((resolve, reject) => {
            logoImg.onload = resolve
            logoImg.onerror = reject
          })
          const poweredText = 'Powered by Intrare'
          const textWidth = doc.getStringUnitWidth(poweredText) * doc.internal.getFontSize() / doc.internal.scaleFactor
          const logoHeight = 10
          const logoWidth = logoHeight * (202 / 184)
          const spacing = 2
          const totalWidth = logoWidth + spacing + textWidth
          const startX = (ticketW - totalWidth) / 2
          doc.addImage(logoImg, 'PNG', startX, currentY - logoHeight + 2, logoWidth, logoHeight)
          doc.text(poweredText, startX + logoWidth + spacing, currentY)
        } catch (e) {
          console.error('Error loading logo image:', e)
          centerText('Powered by Intrare', currentY)
        }
        // Abrir PDF en nueva pestaña para imprimir
        const pdfBlob = doc.output('blob')
        const pdfUrl = URL.createObjectURL(pdfBlob)
        const printWindow = window.open(pdfUrl, '_blank')
        if (printWindow) {
          printWindow.addEventListener('load', () => {
            printWindow.print()
          })
        }
      } catch (err) {
        console.error('Error generando ticket:', err)
      } finally {
        this.printingTicket = false
      }
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse)
        this.dialogInitial = false
      }
    },
    cleanFields () {
      this.errors = []
      this.notes = ''
      this.idHouse = {
        id: ''
      }
      this.idHouse2 = []
      this.idService = ''
      this.first_name = ''
      this.imageCaptured = ''
      this.imageCapturedAdditionalPerson = ''
      this.bandMsgVacationMode = false
      this.bandInstructions = false
      this.msgInstructions = ''
      this.bandParcel = false
      this.additionalPersons = []
      this.idGuestByEvent = null
      this.idGuestByDelivery = null
    },
    clear: function () {
      this.cleanFields()
      this.errors = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }

    .camera-preview-box {
        width: 164px;
        height: 164px;
        background-color: grey;
        overflow: hidden;
        display: inline-block;
    }

    /* Fuerza al <video> interno de vue-web-cam a llenar el contenedor */
    .camera-preview-box /deep/ video {
        width: 164px;
        height: 164px;
        object-fit: cover;
        display: block;
    }
</style>
